
import React from "react"
import StateHandler from "src/states/StateHandler";
import EventHandler from "src/states/EventHandler";

class EventAdaptingStateHandler implements StateHandler, EventHandler {
    delegateStateHandler: StateHandler
    listeners: any
    constructor(delegateStateHandler: StateHandler) {
        this.delegateStateHandler = delegateStateHandler
        this.handle = this.handle.bind(this);
        this.listeners = {}
    }

    handle(event: React.ChangeEvent<any>) {
        const {name, value} = event.target
        this.set(name, value)
    }

    addListener(key: string, listener: (state: any) => void) {
        if (key in this.listeners) {
            this.listeners[key].push(listener)
        } else {
            this.listeners[key] = [listener]
        }
    }

    get(key: string) {
        return this.delegateStateHandler.get(key)
    }

    set(id: string, state: any) {
        this.delegateStateHandler.set(id, state)
        if (id in this.listeners) {
            this.listeners[id].forEach((listener: (state: any) => void) => {
                listener(state)
            })
        }
    }
}

export default EventAdaptingStateHandler
